type Key = 'PROJECTS_SHARD_CONFIG_BY_PROJECT_ID' | 'FIBR-LANGUAGE' | 'FIBR-INVITATION-TOKEN';

export const setLocalStorage = (key: Key, value: string) => {
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: Key) => {
  return localStorage.getItem(key);
};
